export enum FieldType {
	OPTION = 'option',
	UPLOAD = 'upload',
	TEXT = 'text',
	DATE = 'date',
	TIME = 'time',
}
